/**
 * @fileoverview added by tsickle
 * Generated from: models/remote-key-transfer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/**
 * @record
 */
export function RemoteKeyTransfer() { }
if (false) {
    /** @type {?} */
    RemoteKeyTransfer.prototype.otherWorker;
    /** @type {?} */
    RemoteKeyTransfer.prototype.keys;
    /** @type {?} */
    RemoteKeyTransfer.prototype.keysToTransfer;
    /** @type {?} */
    RemoteKeyTransfer.prototype.keysToCollectForDisplay;
}
/** @type {?} */
export var remoteKeyTransfer = model.extend({
    modelName: 'remoteKeyTransfer',
    keysToCollectForDisplay: /**
     * @return {?}
     */
    function () {
        if (this.keys.length === 0) {
            return '';
        }
        else if (this.keys.length === 1) {
            return this.keys[0].code;
        }
        else {
            /** @type {?} */
            var keyCodes = this.keys.map((/**
             * @param {?} key
             * @return {?}
             */
            function (key) { return key.code; }));
            /** @type {?} */
            var startString = keyCodes.slice(0, -1).join(', ');
            /** @type {?} */
            var endString = ' and ' + keyCodes.pop();
            return startString + endString;
        }
    }
});
